<template>
  <section :class="$style['unbounce-rewards-rows']">
    <home-info-row
      headline="Take your share"
      :firstCategoryParagraphs="row1.firstCategoryParagraphs"
      :containerClass="$style['unbounce-rewards-rows']"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row1.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :src="src"
        :class="$style['rewards-container']"
        :alt="alt"
      />
    </home-info-row>
    <home-info-row
      headline="Did you consent?"
      :firstCategoryParagraphs="row2.firstCategoryParagraphs"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row2.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :class="$style['rewards-container']"
        :src="src"
        :alt="alt"
      />
    </home-info-row>
    <home-info-row
      headline="How it works"
      :firstCategoryParagraphs="row3.firstCategoryParagraphs"
      :class="$style['row-container']"
    >
      <rewards-item
        v-for="(paragraphs, index) in row3.secondCategoryParagraphs"
        :key="index"
        :paragraphs="paragraphs"
        :class="$style['rewards-container']"
        :src="src"
        :alt="alt"
      />
    </home-info-row>
  </section>
</template>

<script>
import HomeInfoRow from '@/components/home/HomeInfoRow.vue';
import RewardsItem from '@/components/rewards/RewardsItem.vue';

export default {
  components: {
    HomeInfoRow,
    RewardsItem,
  },
  data() {
    return {
      row1: {
        firstCategoryParagraphs: [
          'Big Tech firms are secretly collecting hundreds of data points about you and selling them to advertisers.',
          'FairView lets you take back the control and charge advertisers for the right to display ads to you.',
        ],
        secondCategoryParagraphs: [
          ['An average internet user could be earning hundreds of pounds a year simply by installing our extension.'],
          ['View ads from the extension and advertisers pay you for it.'],
        ],
      },
      row2: {
        firstCategoryParagraphs: [
          'Big Tech firms are collecting and selling your information and making huge profits.',
        ],
        secondCategoryParagraphs: [
          ['You can bypass Big Tech with FairView.'],
          ['You specify what information about you advertisers are allowed to use.'],
          ['Advertisers pay you money for the right to target ads at you.'],
        ],
      },
      row3: {
        firstCategoryParagraphs: [
          'The internet is fueled by spying on you to sell your data to advertisers. All of this is designed to show you relevant ads while ignoring your privacy and keeping you hooked on social media platforms.',
          'Through complex channels, hundreds of companies are doing this to take a share of the $300 billion a year ads industry.',
        ],
        secondCategoryParagraphs: [
          ['FairView was created to give users a share of the advertising money.'],
          ['You will be paid directly for agreeing to have extra adverts at the side of your browser.'],
          ['You see the ads useful to you and make money doing so.'],
        ],
      },
      src: '/img/icons/check.svg',
      alt: this.$t('rewards.group-1.iconAlt'),
    };
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/styles/colors.scss';

.unbounce-rewards-rows {
  section,
  p {
    margin-bottom: 0 !important;
  }
  iframe {
    width: 470px;
    height: 264px;
  }
  p {
    padding-bottom: 15px;
    color: $dark-grey !important;
    font-size: 14px;
  }
}

.rewards-container {
  font-weight: bold;
}

.row-container {
  margin: 50px;
  width: auto !important;

  section {
    width: auto !important;
  }
}

.row-1-img {
  width: 471px !important;
  height: 313px !important;
}
</style>
